import { Modal, PrimaryButton } from "@fluentui/react";
import React, { useEffect, useState, useContext } from "react";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import ModalMain from "../../../../../components/Modal/ModalMain";
import ModalFooter from "../../../../../components/Modal/ModalFooter";
import ModalHeader from "../../../../../components/Modal/ModalHeader";
import { reportVersionControl, reportVersionControlMSWord } from "../../../../../service/StudyListService";
import studylistContext from "../../../../../context/studylist/StudylistContext";
import studyReportContext from "../../../../../context/studyreport/StudyReportContext";
import themeContext from "../../../../../context/theme/ThemeContext";
import { previewWordHistoryPdfReport } from "../../../../../service/StudyReportService";

const ReportVersion = (props) => {
  const [loading, setLoading] = useState(false);
  const { showVersionModalForReport, setShowVersionModalForReport } =
    useContext(studylistContext);
  const [reportVersionData, setReportVersionData] = useState([]);
  const [t] = useTranslation();

  let PrimaryButtonList = [
    {
      title: t("button.close"),
      onclick: () => props.setShowReportHistoryModal(false),
    },
  ];

  const handleReturnedStudy = async () => {
    setLoading(true);
    let response = null;
    if(props.wordFilePath && !props.extReportReceived){
      response = await reportVersionControlMSWord(props.studyId);
    }else{
      response = await reportVersionControl(props.studyId, props.extReportReceived);
    }
     
    if (response.status == 200 && response.data.result == "SUCCESS") {
      console.log("--- Report Version Control ----");
      if(props.wordFilePath && !props.extReportReceived){
        setReportVersionData(response.data.data);
      }else{
        setReportVersionData(response.data.data.reportVersionDtos);
      }
      
      setLoading(false);
    } else {
      setLoading(false);
    }
    console.log(response);
  };

  useEffect(() => {
    handleReturnedStudy();
  }, []);

  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal = {true}
        heading={`${t("report-version.title")} ${
          reportVersionData.length > 0
            ? "(" + reportVersionData.length + ")"
            : ""
        }`}
        handleCancel={() => props.setShowReportHistoryModal(false)}
      />
    ),
    body: <ReportVersionModal msWord={props.wordFilePath} extReportReceived={props.extReportReceived} reasons={reportVersionData} loading={loading} setShowReportHistoryModal = {props.setShowReportHistoryModal} />,
    footer: (
      <ModalFooter
        PrimaryButtonList={[]}
        DefaultButtonList={PrimaryButtonList}
      />
    ),
    width: "500px",
  };

  return (
    <>
      <ModalMain
        updatedModal = {true}
        modalDetails={modalDetails}
        showModal={props.showReportHistoryModal}
      />
    </>
  );
};

export default ReportVersion;

export const ReportVersionModal = (props) => {
  const { showVersionModalForReport, setShowVersionModalForReport } =
    useContext(studylistContext);
  const [t] = useTranslation();
  const { getThemeColor } = useContext(themeContext);

  const { handlePreviewReportVersion } = useContext(studyReportContext);

  let isBvpPlatform = (process.env.REACT_APP_BVP_PLATFORM == "true" || process.env.REACT_APP_BVP_PLATFORM == true) ? true : false;

  const tableStyle = {
    width: "100%",
    color: getThemeColor("primary-color"),
    fontWeight: "400",
    fontFamily: "Open Sans",
  };

  const headStyle = {
    padding: "10px",
    textAlign: "center",
    border: "1px solid #878282",
  };

  const bodyRowDataStyle = {
    padding: "10px",
    textAlign: "left",
    border: "1px solid #878282",
  };

  const reasonBodyStyle = {
    padding: "10px",
    textAlign: "left",
    border: "1px solid #878282",
    wordBreak: "break-all",
  };

  const contentStyles = {
    root: {
      backgroundColor: "rgb(22, 21, 20, 0.7)",
    },
  };

  const noReason = {
    padding: "10px",
    textAlign: "center",
    color: getThemeColor("primary-color"),
  };

  const customSpinnerStyle = {
    circle: {
      height: "20px",
      width: "20px",
      borderWidth: "3px",
    },
  };

  const thheadStyle = {
    padding: "10px",
    textAlign: "center",
    border: "1px solid #878282",
    borderBottom:'none'
  };

  return (
    <>
      {props.loading ? (
        <Spinner size={SpinnerSize.small} styles={customSpinnerStyle} />
      ) : (
        <div className="upload-study-modal-container">
          <div className="container-content">
            {props.reasons.length > 0 ? (
              <table style={tableStyle}>
                <thead>
                  <tr>
                    {/* {props.msWord ?  */}
                    <React.Fragment>
                    <th style={thheadStyle}>{t("report-version.reported-by")}</th>
                    <th style={thheadStyle}>{t("report-version.report-status")}</th>
                    <th style={thheadStyle}>{t("report-version.reported-date")}</th> 
                    {isBvpPlatform && <th style={thheadStyle}>{t("report-version.submission")}</th>}
                    <th style={thheadStyle}>{t("report-version.report")}</th>
                    </React.Fragment>
                    {/* :  <React.Fragment>
                      <th style={thheadStyle}>{t("report-version.reported-by")}</th>
                      <th style={thheadStyle}>{t("report-version.reported-date")}</th>
                      <th style={thheadStyle}>{t("report-version.report")}</th> 
                    </React.Fragment>
                    } */}
                  </tr>
                  <tr style={headStyle}></tr>
                  <tr style={headStyle}></tr>
                  <tr style={headStyle}></tr>
                </thead>
                <tbody id="unassign-modal_body">
                  {props.reasons.map((reason, index) => (
                    <tr key={index}>
                      {props.msWord ? 
                    <>
                     <td style={bodyRowDataStyle}>{reason.reportedBy}</td>
                      <td style={bodyRowDataStyle}>{reason.reportStatus}</td>
                      
                      <td style={bodyRowDataStyle}>{reason.reportedDate}</td>
                      {isBvpPlatform && <td style={bodyRowDataStyle}>{reason.submissionDisabled}</td>}
                      <td style={reasonBodyStyle}>
                       {reason.isWordAvailable ? <PrimaryButton
                           text={t("report-version.view-report")}
                           style={{
                             whiteSpace:'nowrap'
                           }}
                           onClick={() => {previewWordHistoryPdfReport(reason.reportHistoryId) }}
                       />:<></>

                       } 
                      </td>
                    </>
                    
                    :
                    <>
                      <td style={bodyRowDataStyle}>{reason.updatedByName}</td>
                      <td style={bodyRowDataStyle}>{reason.reportStatus}</td>
                      <td style={bodyRowDataStyle}>{reason.updatedAt}</td>
                      {isBvpPlatform && <td style={bodyRowDataStyle}>{reason.submissionDisabled}</td>}
                      <td style={reasonBodyStyle}>
                        <PrimaryButton
                          text={t("report-version.view-report")}
                          style={{
                            whiteSpace:'nowrap'
                          }}
                          onClick={() => {props.extReportReceived ? handlePreviewReportVersion(reason.versionId) :
                                setShowVersionModalForReport(()=>{
                                    const newItem = {...showVersionModalForReport};
                                    newItem.show = true;
                                    newItem.data = reason?.studyReportDtos
                                    return newItem;
                                });
                           
                          }}
                      />
                      </td></>}
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p style={noReason}>{t("report-version.no-reported-history")}</p>
            )}
          </div>
        </div>
      )}
    </>
  );
};
